export function PaperPlaneMark() {
  return (
    <svg className="plane-mark" viewBox="0 0 240 170" aria-hidden="true" data-testid="login-plane-mark">
      <path
        className="plane-mark-trail"
        pathLength="1"
        id="plane-mark-path"
        d="M 10 158 C 52 150, 80 132, 106 108 C 126 90, 140 66, 130 50 C 122 38, 102 40, 100 56 C 98 74, 118 84, 138 80 C 162 76, 190 56, 212 26"
      />
      <g className="plane-mark-plane">
        <path d="M 10 0 L -8 -7 L -2 0 L -8 7 Z" />
        <path d="M 10 0 L -2 0" />
        <animateMotion dur="7.5s" repeatCount="indefinite" rotate="auto" keyPoints="0;1;1" keyTimes="0;0.6;1" calcMode="linear">
          <mpath href="#plane-mark-path" />
        </animateMotion>
      </g>
    </svg>
  );
}
